import { createAction, props } from "@ngrx/store";

export const setFromTo = createAction("[Header Component] set FROM", props<{ from: Date; to: Date | undefined }>());
export const reset = createAction("[Header Component] Reset");
